import React, { useState } from 'react';

import FilterTitle from './FilterTitle';
import { capitalizeFirstLetter } from '../../blocks/utils/general-utils';

const getPostType = ( items ) => {
  const postType = items
    .map( ( post ) => post.post_type ? post.post_type : post.type )
    .filter( ( value, index, arr ) => arr.indexOf( value ) === index )
    .toString();
  return postType.includes( 'book' ) ? postType.replace( 'book', '' ) : postType;
};

/**
 * FilterNavItem
 *
 * Navigation links to category and imprint posts
 *
 * @param {Object} props
 * @param {Array} props.items
 */

const FilterNavItems = ({ items = [] }) => {
  const [ isActive, setIsActive ] = useState( false );

  const postType = getPostType( items );

  const filterTitleClickHandler = () => {
    setIsActive( cur => !cur );
  };

  return (
    <li
      className={`filters__list-item text-[#121212] ${isActive ? 'is-active' : 'is-inactive'}`}
      data-nav-item={postType}
    >
      <FilterTitle
        classes={`filters__btn--nav-item ${isActive ? 'mt-0 mb-10' : ''}`}
        title={postType === 'agerange' ? 'Age Range' : capitalizeFirstLetter( postType ) }
        onClick={filterTitleClickHandler}
      />
      <ul className={`filters__submenu text-14 flex-col gap-15 w-full list-none mb-20 px-0 ${items?.length > 7 ? 'lg:overflow-y-scroll lg:h-[267px]' : ''}`}>
        {items?.map( ( post ) => (
          <li className='filters-nav__list-item mb-0' key={post.id ? post.id : post.ID }>
            <a className='filters-nav__link no-underline hover:underline' href={ post.link ? post.link : `/${post.type}/${post.post_name}` }>
              <span dangerouslySetInnerHTML={{ __html: post.post_title ? post.post_title : post.title.rendered }} />
            </a>
          </li>
        ) )}
      </ul>
    </li>
  );
};

export default FilterNavItems;
